import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ t("path", {
  fill: "#1F2937",
  d: "M8 8a.667.667 0 1 0 0-1.333A.667.667 0 0 0 8 8"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M10.667 8a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333M5.333 8a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M12.667 2H3.333a2 2 0 0 0-2 2v10a.667.667 0 0 0 1.007.573l2.993-1.813a.67.67 0 0 1 .367-.093h6.967a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m.666 8.667a.667.667 0 0 1-.666.666H5.7a2 2 0 0 0-1.033.287l-2 1.2V4a.667.667 0 0 1 .666-.667h9.334a.667.667 0 0 1 .666.667z"
}, null, -1), c = [
  a,
  n,
  s
];
function d(h, i) {
  return e(), l("svg", o, [...c]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
